var map = {
	"./data_business": 181,
	"./data_business.json": 181,
	"./data_student": 182,
	"./data_student.json": 182,
	"./landing_page": 73,
	"./landing_page.json": 73,
	"./mapping_business": 183,
	"./mapping_business.json": 183,
	"./mapping_student": 184,
	"./mapping_student.json": 184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;